import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const getCustomizationListing = (isLive: boolean) => {
  const params = { is_live: isLive };

  return axiosPrivate.get(`/dashboard/api/v1/checkout-customization`, { params: params });
};